import React, {useEffect, useMemo, useRef, useState} from "react";
import {
    BottomRightHalo,
    Wrapper,
    InfoButton,
    PlayPauseButton,
    TOFlowContainer,
    TOFlowWrapper,
    TOFSetting,
    // Footer,
    SettingsBottomButton, FavoritesBottomButton, TOFMainContainer, MenuButton,
} from "./TOFlow.styled";
import Footer from "../Footer/Footer";
import {ReactComponent as MiniLogo} from "../../assets/icons/miniLogo.svg";
import {ReactComponent as NewTOF} from "../../assets/icons/new_tof.svg";
import {ReactComponent as PlayNew} from "../../assets/icons/play_new.svg"
import {ReactComponent as PauseNew} from "../../assets/icons/pause_new.svg"
import {ReactComponent as Gear} from "../../assets/icons/gear_new.svg"
import {ReactComponent as BackDownNew} from "../../assets/icons/back_arrow_new.svg"
import {ReactComponent as Favorite} from "../../assets/icons/fav.svg"
import {ReactComponent as Info} from "../../assets/icons/info.svg"
import {ReactComponent as MenuIcon} from "../../assets/icons/menu.svg"

import {useMediaQuery} from "../../customHooks";
import {ScrollList} from "../ScrollList/ScrollList";
import {useGetToFlowQuery} from "../../redux/rtkApi/toFlowApi";
import {useSelector} from "react-redux";
import {selectors} from "../../redux/selectors";
import {getState, useAppDispatch} from "../../redux/store";
import {
    setFeeFilter, setFilterPercent, setHiddenExchanges,
    setHideNumFilter, setHighlightFrom, setIsFavoriteOpen, setIsInfoOpen,
    setIsMenuOpen, setIsPlay, setIsSettingsOpen,
    setSelectedItem, setSelectedItemIndex
} from "../../redux/actions";
import TODetails from "../TODetails/TODetails";
import {TOFSettings} from "../Settings/Settings";
import {TOFInfo} from "../Info/Info";
import {Favorites} from "../Favorites/Favorites";
import {Menu} from "../Menu/Menu";
import {ITOHistory, ITOHistoryWithId} from "../../types";
import {generateBaseURLWebSocket} from "../../redux/axios.config";
import {LANG_KEY} from "../../constants";



export const TOFlow: React.FC = () => {
    const isTelegram = !!window.Telegram?.WebApp;
    const isMobile = window.Telegram?.WebApp.platform === "ios" || window.Telegram?.WebApp.platform === "android";
    const isWeb = window.Telegram?.WebApp.platform === "unknown" && !isMobile;
    const isDesktop = isTelegram && !isMobile && !isWeb
    const isCompactHeight = useMediaQuery('(max-height: 940px)')
    const dispatch = useAppDispatch()
    const isToDetailsOpen = useSelector(selectors.selectIsToDetailsOpen)
    const isMenuOpen = useSelector(selectors.selectIsMenuOpen)
    const selectedItem = useSelector(selectors.selectSelectedItem)
    const selectedItemIndex = useSelector(selectors.selectSelectedItemIndex)
    const selectedPrecisions = useSelector(selectors.selectSelectedPrecisions)
    const isPlay = useSelector(selectors.selectIsPlay)
    const isFavoriteOpen = useSelector(selectors.selectIsFavoriteOpen)
    const isSettingsOpen = useSelector(selectors.selectIsSettingsOpen)
    const isInfoOpen = useSelector(selectors.selectIsInfoOpen)
    const hiddenExchanges = useSelector(selectors.selectHiddenExchanges)
    const hideLowerThan = useSelector(selectors.selectHideNumFilter)
    const highlightFrom = useSelector(selectors.selectHighlightFrom)
    const filterPercent = useSelector(selectors.selectFilterPercent)
    const substructFee = useSelector(selectors.selectFeeFilter)
    const favorites = useSelector(selectors.selectFavorites)
    const deleted = useSelector(selectors.selectDeleted)
    const { data: toFlow = [] } = useGetToFlowQuery(
        {
            hiddenExchanges,
            hideLowerThan,
            highlightFrom,
            filterPercent,
            substructFee,
            favorites,
            deleted,
        },
        {
            skip: isPlay || Boolean(selectedItem) || isMenuOpen,
            refetchOnReconnect: true,
            // refetchOnFocus: true,
        },
    )

    // const reversed = useMemo(
    //     () => [...toFlow].reverse(),
    //     [...toFlow]
    // )
    // const reversed = [...toFlow].reverse()
    return (
      <Wrapper isWeb={isWeb}>
        <TOFlowWrapper isDesktop={isDesktop}>
          {isMenuOpen && !selectedItem && (<Menu isMobile={isMobile}/>)}
          <TOFlowContainer $isTgView={isMobile}>
            <TOFSetting isOpen={isInfoOpen || isSettingsOpen} isDesktopTgApp={isTelegram && !isMobile}>
               <MenuButton
                   onClick={() => {
                       dispatch(setIsMenuOpen(true))
                       // setIsSettingsOpen(false)
                   }}
                   isOpen={isMenuOpen}
                   isMobile={isMobile}
               >
                   <MenuIcon></MenuIcon>
               </MenuButton>
                <div>
                    <NewTOF/>
                </div>
                <InfoButton
                      onClick={() => {
                          dispatch(setSelectedItem(undefined))
                          dispatch(setIsInfoOpen(!isInfoOpen))
                          dispatch(setSelectedItemIndex(undefined))
                          dispatch(setIsSettingsOpen(false))
                          dispatch(setIsFavoriteOpen(false))
                          dispatch(setIsMenuOpen(false))
                          dispatch(setIsPlay(true))
                      }}
                      isOpen={isInfoOpen}
                      isMobile={isMobile}
                >
                    <Info/>
                </InfoButton>
            </TOFSetting>
              <TOFMainContainer isOpen={isInfoOpen || isSettingsOpen} isDesktopTgApp={isTelegram && !isMobile}>
                  {isFavoriteOpen && !selectedItem && !isInfoOpen && !isSettingsOpen && (<Favorites/>)}
                  {isInfoOpen && !isSettingsOpen && !selectedItem && (<TOFInfo/>)}
                  {isSettingsOpen && !selectedItem && !isInfoOpen && !isFavoriteOpen && (<TOFSettings isMobile={isMobile}/>)}
                  {!selectedItem && !isInfoOpen && !isSettingsOpen && !isFavoriteOpen && !isMenuOpen && (<ScrollList
                      items={toFlow}
                      // items={reversed}
                      isHigh={isCompactHeight}
                      isWeb={isWeb}
                      isDesktop={isDesktop}
                      isMobile={isMobile}
                  />)}
                  {selectedItem && typeof selectedItemIndex === 'number' && (<TODetails isOpen={isToDetailsOpen} selected_item={selectedItem} isActive={isToDetailsOpen} selectedPrecisions={selectedPrecisions} selectedIndex={selectedItemIndex}/>)}
              </TOFMainContainer>
              <Footer/>
          </TOFlowContainer>
          <BottomRightHalo/>
        </TOFlowWrapper>
      </Wrapper>
  )
}





{/*<Footer>*/}
{/*  <FavoritesBottomButton isOpen={isFavoriteOpen} onClick={() => {*/}
{/*      setIsFavoriteOpen((prev) => !prev)*/}
{/*      dispatch(setSelectedItem(undefined))*/}
{/*      dispatch(setSelectedItemIndex(undefined))*/}
{/*      setIsInfoOpen(false)*/}
{/*      setIsSettingsOpen(false)*/}
{/*  }}>*/}
{/*      <Favorite/>*/}
{/*  </FavoritesBottomButton>*/}
{/*  <PlayPauseButton*/}
{/*      isStopped={play && !isSettingsOpen && !isInfoOpen && !isFavoriteOpen}*/}
{/*      onClick={() => {*/}
{/*      if (selectedItem || isSettingsOpen || isInfoOpen || isFavoriteOpen) {*/}
{/*          if (selectedItem) {*/}
{/*              dispatch(setSelectedItem(undefined))*/}
{/*          }*/}
{/*          if (isSettingsOpen) {*/}
{/*              setIsSettingsOpen(false)*/}
{/*          }*/}
{/*          if (isInfoOpen) {*/}
{/*              setIsInfoOpen(false)*/}
{/*          }*/}
{/*          if (isFavoriteOpen) {*/}
{/*              setIsFavoriteOpen(false)*/}
{/*          }*/}
{/*      } else {*/}
{/*        setPlay((prev) => !prev)*/}
{/*    }*/}
{/*  }}>*/}
{/*    { selectedItem || isSettingsOpen || isInfoOpen || isFavoriteOpen ? (<BackDownNew/>) : play ? (<PlayNew/>) : (<PauseNew/>)}*/}
{/*  </PlayPauseButton>*/}
{/*  <SettingsBottomButton*/}
{/*      isOpen={isSettingsOpen}*/}
{/*      onClick={() => {*/}
{/*        setIsSettingsOpen((prev) => !prev)*/}
{/*        setIsInfoOpen(false)*/}
{/*          setIsFavoriteOpen(false)*/}
{/*          dispatch(setSelectedItem(undefined))*/}
{/*          dispatch(setSelectedItemIndex(undefined))*/}
{/*        // setHighlightFrom('')*/}
{/*        // setSubstructFeeFrom('')*/}
{/*        // setHideLowerThan('')*/}
{/*      }}>*/}
{/*    <Gear/>*/}
{/*  </SettingsBottomButton>*/}
{/*</Footer>*/}